import * as React from 'react';
import { Button } from '@fluentui/react-components';
import { Feed16Regular } from '@fluentui/react-icons'; // Adjust this import to the correct icon

import styles from './Feedback.module.css';

interface Props {
    className?: string;
    onClick: () => void;
    disabled?: boolean;
}

export const FeedbackButton = ({ className, disabled, onClick }: Props) => {
    return (
        <div className={`${styles.container} ${className ?? ""}`}>
            <Button
                icon={<Feed16Regular />} // Use the specific icon you want
                disabled={disabled}
                onClick={onClick}
            >
                {"Feedback"}
            </Button>
        </div>
    );
};
